export enum UserType {
    CONNECTED_B2B = 'connected-b2b',
    PDD_B2B = 'pdd-b2b',
    SSO = 'sso',
    YANDEX_TEAM = 'yandex-team',
    B2C = 'b2c',
    ANONYM = 'anonym',
    LEGAL_ENTITY = 'legal-entity',
}

export const FROM_PASSPORT = 'from_passport';
